module.exports = __webpack_public_path__ + "static/media/login_bottom.0bf7ae6f.png";